import React, { Component } from "react";
import { Form, Input } from "antd";
import styles from "../index.module.less";
import { observer } from "mobx-react";

const FormItem = Form.Item;

@observer
class LatinSpinner extends Component {
	render() {
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label={this.props.username ? "Username" : "Email address"}>
					{this.props.form.getFieldDecorator(this.props.emailAddressField)(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="API Key">
					{this.props.form.getFieldDecorator(this.props.apiKeyField)(
						<Input type="text" />
					)}
				</FormItem>
			</Form>
		);
	}
}

export default LatinSpinner;
